import { FETCH_ACTIONS } from '../constants/action.constants';

export function fetchStart(resource) {
  return {
    key: resource.key,
    type: FETCH_ACTIONS.START
  };
}

export function fetchReset(resource) {
  return {
    key: resource.key,
    type: FETCH_ACTIONS.RESET
  };
}

export function fetchDone(resource) {
  return {
    key: resource.key,
    type: FETCH_ACTIONS.DONE
  };
}

export function fetchError(resource, payload) {
  return {
    key: resource.key,
    type: FETCH_ACTIONS.ERROR,
    payload
  };
}
